/**
 * The region vocabulary for the zone library (slice 24e).
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * WHY A LIST AND NOT A TEXT BOX.
 * ─────────────────────────────────────────────────────────────────────────────
 * 24f shipped `region` as free text and flagged the drift in the same breath.
 * The nine zones a real customer drew are named `Home`/`home`, `Wado`/`wado`/
 * `wado2`, `Town`, `laami` — that is what free text does to a field people type
 * into repeatedly. A region is a browse AXIS: `Banadir` and `banadir` and
 * `Benadir` would be three headings for one place, and a tenant filtering by one
 * would silently miss the templates filed under the others.
 *
 * 🔴 THERE IS NO "OTHER" AND NO FREE-TEXT FALLBACK, ON PURPOSE. An escape hatch
 * is how a controlled vocabulary decays back into the thing it replaced — it
 * would be reached for exactly when someone is in a hurry, which is when the
 * typo happens. An unlisted region needs a change to this file, which is a
 * deliberate act with a diff.
 *
 * A template may still have NO region at all (`null`), which is what an
 * unclassified one honestly is. That is a different thing from "Other": it says
 * nobody has filed this yet, rather than inventing a bucket to hide it in.
 *
 * Somalia's 18 administrative regions. Reviewed by Mahad on the slice plan
 * before this file was written — the names are public administrative fact, but
 * WHICH list ships is a product decision and it was his to make.
 */
export const REGIONS = [
  'Awdal',
  'Bakool',
  'Banadir',
  'Bari',
  'Bay',
  'Galguduud',
  'Gedo',
  'Hiiraan',
  'Jubbada Dhexe',
  'Jubbada Hoose',
  'Mudug',
  'Nugaal',
  'Sanaag',
  'Shabeellaha Dhexe',
  'Shabeellaha Hoose',
  'Sool',
  'Togdheer',
  'Woqooyi Galbeed',
] as const;

export type Region = (typeof REGIONS)[number];
